import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/Layout";
import WithI18next from "../components/WithI18next";

const PostTemplate = ({ data }) => {
  return (
    <Layout
      title={data.wpPost.seo.title}
      description={data.wpPost.seo.metaDesc}
    >
      <div className="pt-5 post">
        <div className="container page-content py-5">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <h1
                className="mb-3"
                dangerouslySetInnerHTML={{ __html: data.wpPost.title }}
              />
              <p className="mb-5">{data.wpPost.date}</p>
              <div
                dangerouslySetInnerHTML={{
                  __html: `<div> ${data.wpPost.content} </div>`,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default WithI18next()(PostTemplate);

export const query = graphql`
  query ($id: Int!, $wpLocale: String!, $wpGlobalConfig: String!) {
    wpPost(
      databaseId: { eq: $id }
      language: { locale: { eq: $wpLocale } }
      acfGlobalConfiguration: { gcLinkTo: { in: [".all", $wpGlobalConfig] } }
    ) {
      title
      content
      excerpt
      date(formatString: "MMMM DD, YYYY")
      seo {
        # canonical
        # focuskw
        metaDesc
        # metaKeywords
        # metaRobotsNofollow
        # metaRobotsNoindex
        # opengraphAuthor
        # opengraphDescription
        # opengraphModifiedTime
        # opengraphPublishedTime
        # opengraphPublisher
        # opengraphSiteName
        # opengraphTitle
        # opengraphType
        # opengraphUrl
        title
        # twitterDescription
        # twitterTitle
      }
    }
  }
`;
